import {
  Component,
  ContentChild,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'aid-add-button',
  template: `
    <div>
      @if (menu) {
        <a class="menu" [matMenuTriggerFor]="menu">
          <button mat-mini-fab color="primary" (click)="onClick($event)">
            <mat-icon data-cy="add-project-btn" svgIcon="add"></mat-icon>
          </button>
        </a>
      }
      @if (!menu) {
        <a>
          <button mat-mini-fab color="primary" (click)="onClick($event)">
            <mat-icon data-cy="add-project-btn" svgIcon="add"></mat-icon>
          </button>
        </a>
      }
    </div>
  `,
  styleUrls: ['./add-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddButtonComponent implements OnInit {
  @Output()
  add: EventEmitter<void> = new EventEmitter<void>();
  @ContentChild('menu')
  menu?: MatMenu;
  constructor() {}

  ngOnInit() {}

  onClick(event: MouseEvent) {
    this.add.emit();
  }
}
